// notificationsShared.js — seam d'icônes + référentiels du module Notifications mobile.
//
// ── Seam d'icônes ───────────────────────────────────────────────────────────
// <Ico> rend un <i> STABLE (wrapper dimensionné par la CSS .enf i / .enf .nic i)
// et y place une icône lucide-react. On utilise le paquet `lucide-react` déjà
// présent dans l'app (cf. src/mobile/produits/productsShared.js) — PAS le script
// lucide UMD global (non chargé par l'app). Tout nom inconnu retombe sur `Circle`.
import React from "react";
import {
  AlertTriangle,
  ArrowRight,
  ArrowUpRight,
  Ban,
  Banknote,
  Bell,
  BellOff,
  Box,
  Building2,
  Calendar,
  Check,
  CheckCheck,
  CheckCircle2,
  ChevronLeft,
  ChevronRight,
  Circle,
  ClipboardCheck,
  Clock,
  CreditCard,
  EyeOff,
  FileText,
  GitBranch,
  Hash,
  Inbox,
  Info,
  Layers,
  MapPin,
  MoreHorizontal,
  Package,
  Plus,
  RefreshCcw,
  RotateCcw,
  RotateCw,
  Settings,
  Settings2,
  ShoppingBag,
  ShoppingCart,
  Smartphone,
  Sparkles,
  Store,
  Tag,
  Trash2,
  Truck,
  User,
  Volume2,
  VolumeX,
  Wallet,
  Warehouse,
  X,
  XCircle,
} from "lucide-react";

const ICONS = {
  "alert-triangle": AlertTriangle,
  "arrow-right": ArrowRight,
  "arrow-up-right": ArrowUpRight,
  ban: Ban,
  banknote: Banknote,
  bell: Bell,
  "bell-off": BellOff,
  box: Box,
  "building-2": Building2,
  calendar: Calendar,
  check: Check,
  "check-check": CheckCheck,
  "check-circle-2": CheckCircle2,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "clipboard-check": ClipboardCheck,
  clock: Clock,
  "credit-card": CreditCard,
  "eye-off": EyeOff,
  "file-text": FileText,
  "git-branch": GitBranch,
  hash: Hash,
  inbox: Inbox,
  info: Info,
  layers: Layers,
  "map-pin": MapPin,
  "more-horizontal": MoreHorizontal,
  package: Package,
  plus: Plus,
  "refresh-ccw": RefreshCcw,
  "rotate-ccw": RotateCcw,
  "rotate-cw": RotateCw,
  settings: Settings,
  "settings-2": Settings2,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  smartphone: Smartphone,
  sparkles: Sparkles,
  store: Store,
  tag: Tag,
  "trash-2": Trash2,
  truck: Truck,
  user: User,
  "volume-2": Volume2,
  "volume-x": VolumeX,
  wallet: Wallet,
  warehouse: Warehouse,
  x: X,
  "x-circle": XCircle,
};

export function Ico({ name, className, style }) {
  const Icon = ICONS[name] || Circle;
  return (
    <i className={className} style={style} aria-hidden="true">
      <Icon />
    </i>
  );
}

// Format monétaire F CFA (groupage fr-FR, suffixe "FCFA" pour rester aligné
// avec le reste de l'application).
export const fmt = (n) =>
  new Intl.NumberFormat("fr-FR").format(Math.round(Number(n) || 0)) + " FCFA";

// ── Référentiel des TYPES ────────────────────────────────────────────────────
// ic : nom d'icône (seam)   cls : classe couleur CSS   label : tag affiché
export const TYPES = {
  commande: { ic: "shopping-cart", cls: "t-commande", label: "Nouvelle commande" },
  paiement: { ic: "wallet", cls: "t-paiement", label: "Paiement" },
  stock: { ic: "alert-triangle", cls: "t-stock", label: "Stock" },
  tache: { ic: "clipboard-check", cls: "t-tache", label: "Tâche" },
  systeme: { ic: "settings-2", cls: "t-systeme", label: "Système" },
};

// Filtres (l'ordre = l'ordre d'affichage des chips). `key` "all" = tout.
export const FILTERS = [
  { key: "all", label: "Tout", ic: "inbox" },
  { key: "commande", label: "Commandes", ic: "shopping-cart" },
  { key: "stock", label: "Stock", ic: "alert-triangle" },
  { key: "paiement", label: "Paiements", ic: "wallet" },
  { key: "tache", label: "Tâches", ic: "clipboard-check" },
  { key: "systeme", label: "Système", ic: "settings-2" },
];

// Buckets de regroupement par date. `bucket` de chaque notification → ces clés.
export const BUCKETS = [
  { key: "today", label: "Aujourd'hui" },
  { key: "yesterday", label: "Hier" },
  { key: "earlier", label: "Plus tôt" },
];
